import '../index.css';
import { FaArrowRight } from 'react-icons/fa';
import { memo, useCallback } from 'react';

export function GameCTAButton({ game, onSelect }) {
  const setSpotlight = useCallback((e) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();

    // Use clientX/Y for mouse; touches[0] for touch.
    const pX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    const pY = 'touches' in e ? e.touches[0].clientY : e.clientY;

    const x = ((pX - rect.left) / rect.width) * 100;
    const y = ((pY - rect.top) / rect.height) * 100;

    el.style.setProperty('--x', `${x}%`);
    el.style.setProperty('--y', `${y}%`);
  }, []);

  const resetSpotlight = useCallback((e) => {
    const el = e.currentTarget;
    el.style.setProperty('--x', '50%');
    el.style.setProperty('--y', '50%');
  }, []);

  return (
    <button
      onClick={() => onSelect?.(game)}
      onMouseMove={setSpotlight}
      onMouseLeave={resetSpotlight}
      onTouchStart={setSpotlight}
      onTouchMove={setSpotlight}
      onTouchEnd={resetSpotlight}
      onFocus={resetSpotlight} // nice for keyboard users
      type="button"
      className="group relative h-12 w-56 overflow-hidden rounded-md border border-white/20 bg-black/50 backdrop-blur-sm transition-transform duration-200 ease-out hover:-translate-y-1 focus:outline-none focus-visible:ring-4 focus-visible:ring-white/30"
      style={{
        // defaults if we haven't hovered yet
        ['--x']: '50%',
        ['--y']: '50%',
        color: '#fff',
        cursor: 'pointer',
        // promote to its own layer for smoother updates
        transform: 'translateZ(0)',
      }}
    >
      {/* Spotlight layer (uses CSS variables --x, --y) */}
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-150 group-hover:opacity-100 focus-within:opacity-100"
        style={{
          // Two backgrounds: the soft wash + the moving radial highlight
          background: `
            radial-gradient(
              circle at var(--x) var(--y),
              rgba(255,255,255,0.15) 0%,
              rgba(255,255,255,0.07) 35%,
              rgba(255,255,255,0) 70%
            ),
            rgba(255,255,255,0.05)
          `,
        }}
      />

      <span className="relative flex h-full items-center justify-center gap-2 px-6 text-sm font-medium text-white">
        <span>View new stock</span>
        <FaArrowRight className="h-3 w-3" />
      </span>
    </button>
  );
}

export default memo(GameCTAButton);
